<template>
  <div class="workbench-body">
      <apiScriptView-com
        :work="work"
        @updateApiName="updateApiName"
        @handleismodifyByOldTab="handleismodifyByOldTab"
        @getSourceId="getSourceId"
      />
  </div>
</template>
<script>
import ApiScriptView from './script/apiScript.vue';
export default {
  components: {
    "apiScriptView-com":ApiScriptView
  },
  props: {
    work: Object
  },
  created() {
  },
  mounted() {
  },
  methods: {
    updateApiName(updateName){
      this.$emit("updateApiName",updateName);
    },
    handleismodifyByOldTab(){
       this.$emit("handleismodifyByOldTab");
    },
     getSourceId(dataSourceId){
      this.$emit("getSourceId",dataSourceId);
    },
  },
};
</script>
